import { gql } from '@apollo/client'

export const REPORT_VIOLATION_MUTATION = gql`
  mutation reportViolation($request: ReportViolationRequest) {
    reportViolation(request: $request) {
        reportType
    }
  }
`
